import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

//components
import {
  Curve,
  NewBackButton,
  RightArrowNew,
  VoteIcon,
} from "../../../components/svgs";
import {
  Button,
  Children,
  CurveHolder,
  MainHolder,
  StyledText,
} from "../../../components/common/basic";

// theme
import { useTheme, useLoyalty } from "../../../hooks";
import { BackButton, FeatureHeader } from "../../../components/common";
import ModalHolder from "./modalHolder";

//gif
import loadingGif from "../../../components/images/loader.gif";
import MashupNowButton from "../mashupnwin/components/MashupNowButton";

const MovieManiaVotingHome = () => {
  const { themeContext, theme } = useTheme();
  const [activeMovie, setActiveMovie] = useState(null);
  const [ticketButtonText, setTicketButtonText] = useState("Get ticket");
  const [showLoader, setShowLoader] = useState(false);
  const {
    getMovieList,
    movieListData,
    setSelectedMovie,
    setVoted,
    votingEnd,
    setVotingEnd,
    movieManiaStatus,
  } = useLoyalty();
  let history = useHistory();

  const { movies, voted } = movieListData;

  useEffect(() => {
    setVoted(voted);
  }, [voted]);

  useEffect(() => {
    getMovieList();
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "MovieManiaVotingHome",
        firebase_screen_class: "MovieManiaVotingHome",
      })
    );
  }, []);

  useEffect(() => {
    checkStatus();
  }, []);

  useEffect(() => {
    if (movieManiaStatus?.active) {
      if (activeMovie && movieManiaStatus?.hasReserved) {
        setTicketButtonText("View ticket code");
      }
    } else {
      setTicketButtonText(
        movieManiaStatus?.message || "Movie mania is currently not available."
      );
    }
  }, [movieManiaStatus, activeMovie]);

  useEffect(() => {
    if (movieListData) {
      const { movies } = movieListData;
      const foundActiveMovie = movies.find(({ isActive }) => isActive === true);
      setActiveMovie(foundActiveMovie);
    }
  }, [movieListData]);

  const checkStatus = () => {
    setTimeout(() => {
      if (voted) {
        setVotingEnd(true);
      }
    }, 10000);
  };

  const styles = generateStyles();

  const votetext = movies.votes > 1 ? " votes" : " vote";

  let mashupBackground =
    theme.colors[themeContext.activeTheme]["mashupBackground"];

  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  return (
    <>
      <MainHolder activeTheme={mashupBackground}>
        <Children>
          <BackButton
            onClick={() => {
              history.goBack();
            }}
          />
          <FeatureHeader
            image={movies[0]?.imageUrl}
            title={["Movie Pre-screening"]}
            background={background}
            secondaryBackground={"#fff"}
            description={
              ""
              // "Yo Pulser! Free movie tickets for all movie lovers. Hurry! reserve a free ticket now to be used at Silverbird Cinemas in Accra now."
            }
          />
          <DescriptionBody color={mashupBackground}>
            <ContentHolder>
              {
                <>
                  <NotesHolder>
                    <StyledText
                      size={18}
                      style={{
                        marginBlockStart: 0,
                        marginBlockEnd: 0,
                        marginBottom: "10px",
                        textAlign: "start",
                        fontFamily: "MTNMedium",
                        width: "100%",
                      }}
                    >
                      Movie Pre-screening Rules
                    </StyledText>
                    {Array.isArray(activeMovie?.notes) &&
                      activeMovie?.notes.map((item, index) => {
                        return (
                          <DescriptionItems key={index}>
                            <CircleContainer>
                              <ColorCircle color={background} />
                            </CircleContainer>
                            <StyledText size={12} style={styles.textStyle}>
                              {item}
                            </StyledText>
                          </DescriptionItems>
                        );
                      })}
                  </NotesHolder>
                </>
              }
            </ContentHolder>
            <>
              {movieManiaStatus?.active === true ? (
                <Button
                  style={{
                    height: "40px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginInline: 15,
                    width: "80%",
                  }}
                  disable={!movieManiaStatus?.active}
                  color={background}
                  onClick={() => {
                    if (movieManiaStatus?.active) {
                      setSelectedMovie(activeMovie);
                      history.push(
                        `moviemania/ticketgeneration/${activeMovie._id}`
                      );
                    }
                  }}
                >
                  <StyledText style={{ marginRight: 10 }} color={"white"}>
                    {ticketButtonText}
                  </StyledText>
                </Button>
              ) : (
                <StyledText
                  size={12}
                  style={{
                    fontFamily: "MTNMedium",
                    textAlign: "center",
                    padding: "0 20px 20px 20px",
                    maxWidth: "300px",
                    boxSizing: "border-box",
                    margin: "0 auto",
                  }}
                >
                  {ticketButtonText}
                </StyledText>
              )}
            </>
          </DescriptionBody>
        </Children>
      </MainHolder>
      {showLoader && (
        <ModalHolder>
          <div>
            <img
              alt={"dialog"}
              src={loadingGif}
              style={{ width: "100%", margin: "0 auto" }}
            />
            <StyledText>Checking for available tickets</StyledText>
          </div>
        </ModalHolder>
      )}
    </>
  );
};

const NotesHolder = styled.div`
  padding: 20px;
`;

const DescriptionBody = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  background-color: ${({ color }) => color};
  align-items: center;
  position: relative;
  z-index: 1;
`;

const ContentHolder = styled.div`
  width: 100%;
  height: auto;
`;

const MovieList = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const MovieHolder = styled.div`
  width: 90%;
  height: 103px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  margin-bottom: 10px;
  border-radius: 20px;
  display: flex;
  padding: 5px;
  align-items: center;
`;

const MovieImage = styled.img`
  width: 85px;
  height: 85px;
  border-radius: 5px;
`;

const MovieContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 150px;
  align-items: flex-start;
  margin: 20px;
`;

const Votes = styled.div`
  display: flex;
`;

const DescriptionItems = styled.div`
  display: flex;
  margin-bottom: 10px;
`;

const CircleContainer = styled.div`
  display: flex;
  align-items: flex-start;
  padding-inline: 0px;
`;

const ColorCircle = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background-color: ${({ color }) => color};
  margin-right: 8px;
`;

const generateStyles = () => {
  return {
    textStyle: {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
  };
};

export default MovieManiaVotingHome;
